/**
 * Created by Astha on 12/21/2017.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Portal from './Portal';
import Modal from '../modals/Modal2';
import $ from 'jquery';
import UserProfileImage from './UserProfileImage';
import Authenticator from './../protocol/Authenticator';
import CollectionUtil from './../queries/lightbox/CollectionUtil';
import { Logger } from '../logger/Logger';
import LabelWithValueField from './LabelWithValueField';
import EditUser from './../queries/user/EditUser';
import StringUtil from './../util/StringUtil';
import ParamsUtil from '../util/ParamsUtil';
import EditProfileImagePopover from './EditProfileImagePopover';
import Storage from '../protocol/Storage';

import './EditUserProfile.css';
import ThumbnailUtil from '../util/ThumbnailUtil';
import t from '../i18n/I18n';
import ConnectionUtil from '../util/session/ConnectionUtil';

export default class EditUserAccount extends React.Component {
  messagesEndRef = React.createRef();

  static propTypes = {
    onClose: PropTypes.func
  };
  constructor(props) {
    super(props);
    this.profileFileId = '';
    this.profilePicName = '';
    this.isUserImage = false;
    this.isImageRemoved = false;
    this.passwordChanged = false;
    this.userId = Authenticator.AUTH_DATA.username;
    this.state = {
      oldPass: '',
      newPass: '',
      confirmNewPass: '',
      uploadProfilePic: null,
      editUserErrorInfo: '',
      isUserImage: false,
      showPopover: false
    };
    this.logger = new Logger('EditUserAccount');
    this.editRef = React.createRef();
  }

  componentDidMount() {
    this.isUserImageIdExists();
  }

  handleFilePicker = (event) => {
    try {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (event.target.files && event.target.files.length === 1) {
        this.newProfileImage = event.target.files[0];
        if (this.newProfileImage.type.substr(0, 5) === 'image' && allowedExtensions.exec(this.newProfileImage.name)) {
          this.showPreviewOfUploadProfilePic(this.newProfileImage, event);
          this.isImageRemoved = false;
          this.setState({
            editUserErrorInfo: null,
            isUserImage: true
          });
        } else {
          this.setState({
            editUserErrorInfo: t('UPLOAD_FILE_HAVING_EXTENSIONS')
          });
        }
      }
    } catch (e) {
      console.warn(e);
      this.logger.error(e.message);
    }
  };

  showPreviewOfUploadProfilePic = (file, event) => {
    if (file) {
      let dataTransferFile = file;
      event.target.style.backgroundColor = '';
      let reader = new FileReader();
      reader.onloadend = () => this.setState({ uploadProfilePic: reader.result });
      reader.readAsDataURL(dataTransferFile);
    }
  };
  doesConfirmPasswordMatch = (password, confirmPassword) => {
    return password === confirmPassword;
  };

  isValidValue = (value) => {
    return StringUtil.isNotEmpty(value);
  };

  uploadImageAndEditAccount = (file) => {
    let fileExtension = file.name.split('.').pop();
    const url = ConnectionUtil.getAvatarUploadURL();
    let formData = new FormData();
    formData.append('profilePicFile', file);
    $.ajax({
      url: url,
      type: 'POST',
      processData: false,
      contentType: false,
      async: true,
      cache: false,
      data: formData,
      success: (response) => {
        if (response.success) {
          this.profileFileId = response.fileId;
          this.profilePicName = this.userId + '.' + fileExtension;
          this.editAccount();
        } else {
          this.setState({ editUserErrorInfo: response.error });
        }
      },
      error: (errorId) => {
        window.setError(errorId instanceof String ? errorId.toString() : errorId.statusText);
      }
    });
  };

  editAccount = () => {
    const editUserAccount = new EditUser();
    this.passwordChanged = this.state.oldPass && this.state.newPass ? true : false;
    const promise = editUserAccount.editUser(
      this.userId,
      this.state.oldPass,
      this.state.newPass,
      this.profileFileId,
      this.profilePicName,
      this.isImageRemoved
    );
    promise.then(this.onEditUserSuccess, this.onEditUserFailed);
  };

  onEditUserSuccess = () => {
    this.props.onClose();
    window.gs.infoMsg = t('USER_PROFILE_EDITED');
    let userId = ConnectionUtil.getUserId();
    $.get(
      ParamsUtil.appendAuthData(`${ConnectionUtil.getPreviewServerUrl()}/review/api/user/invalidate-avatar/${userId}`)
    ).always(() => {
      Storage.set('AVATAR_DC', Date.now());
      if (this.passwordChanged && this.props.onPasswordChange) {
        this.props.onPasswordChange();
      } else {
        location.reload(true);
      }
    });
  };

  onEditUserFailed = (errorId) => {
    this.setState({ editUserErrorInfo: errorId.toString() });
  };

  editUserAccount = () => {
    if (this.state.uploadProfilePic && !this.isImageRemoved) {
      this.uploadImageAndEditAccount(this.newProfileImage);
    } else {
      this.editAccount();
    }
  };

  verifyValues = () => {
    let _passwordMatch = this.doesConfirmPasswordMatch(this.state.newPass, this.state.confirmNewPass);
    let _validOldPass = this.isValidValue(this.state.oldPass);
    let _validConfirmNewPass = this.isValidValue(this.state.confirmNewPass);
    let _validNewPass = this.isValidValue(this.state.newPass);

    if (_validOldPass || _validNewPass || _validConfirmNewPass) {
      if (!_validOldPass) {
        this.setState({ editUserErrorInfo: t('OLD_PASSWORD_REQUIRED') });
      } else if (!_validNewPass) {
        this.setState({ editUserErrorInfo: t('NEW_PASSWORD_REQUIRED') });
      } else if (!_validConfirmNewPass) {
        this.setState({ editUserErrorInfo: t('CONFIRM_NEW_PASSWORD_REQUIRED') });
      } else if (!_passwordMatch) {
        this.setState({ editUserErrorInfo: t('CONFIRM_NEW_PASSWORD_NOT_MATCH') });
      } else {
        this.editUserAccount();
      }
    } else if (this.state.uploadProfilePic) {
      this.editUserAccount();
    } else {
      this.props.onClose();
    }
    this.scrollToBottom();
  };
  scrollToBottom = () => {
    this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
  };
  showErrorMessage = () => {
    return <div style={styles.errorMessage}>{this.state.editUserErrorInfo}</div>;
  };

  removeImage = () => {
    Storage.set('AVATAR_DC', Date.now());
    this.setState({ uploadProfilePic: 'images/blank_profile_pic.png', isUserImage: false });
    this.isImageRemoved = true;
  };

  isUserImageIdExists = () => {
    let url = ParamsUtil.append(ConnectionUtil.getPreviewServerUrl() + '/review/api/user/avatarId');
    url = ParamsUtil.appendAuthData(url);
    var formData = new FormData();
    formData.append('userId', Authenticator.AUTH_DATA.username);
    $.ajax({
      url: url,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      data: { userId: Authenticator.AUTH_DATA.username },
      success: (response) => {
        if (response) {
          if (response.avatarId > 0) this.setState({ isUserImage: true });
        }
      },
      error: (errorId) => {
        // window.setError(errorId.statusText);
      }
    });
  };
  render() {
    const { onClose } = this.props;

    const modalProps = {
      name: 'EditUserAccount',
      title: t('EDIT_USER_ACCOUNT'),
      onClose,
      buttons: [
        { onClick: onClose, label: t('CANCEL'), type: 'CANCEL' },
        { onClick: this.verifyValues, label: t('SAVE'), type: 'PRIMARY' }
      ]
    };

    return (
      <Portal defaultOpen={true} closeOnEsc={true}>
        <Modal {...modalProps} closeOnEsc closeOnOutsideClick>
          <div ref={this.messagesEndRef}>
            <div style={styles.userInfo}>
              <div name="editUserProfileImage">
                <div className="img" /*onClick = {()=>this.setState({ showPopover: !this.state.showPopover })}*/>
                  <UserProfileImage
                    size={80}
                    userId={Authenticator.AUTH_DATA.username}
                    displayFullname={true}
                    imageUrl={this.state.uploadProfilePic}
                    style={{ fontColor: 'black' }}
                    vertical
                  />
                </div>
                <div className="edit" ref={this.editRef}>
                  <EditProfileImagePopover
                    uploadPic={() => this.refs.editProfilePic.click()}
                    removePic={this.removeImage}
                    editRef = {this.editRef}
                    showRemovePic={this.state.isUserImage}
                    showPopover={this.state.showPopover}
                  />
                </div>
                <input
                  type="file"
                  ref="editProfilePic"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={this.handleFilePicker}
                />
              </div>
            </div>
            {!CollectionUtil.isLdapRealm() ? (
              <div style={{ display: 'inline-grid', width: '100%', marginTop: '20px', marginBottom: '20px' }}>
                <label style={styles.changePassword}>{t('CHANGE_PASSWORD')}</label>
                <LabelWithValueField
                  labelName={t('OLD_PASSWORD')}
                  style={{ marginTop: '20px' }}
                  value={this.state.oldPass}
                  typeOfInput="password"
                  onChange={(oldPass) => this.setState({ oldPass })}
                />
                <LabelWithValueField
                  labelName={t('NEW_PASSWORD')}
                  style={{ marginTop: '20px' }}
                  value={this.state.newPass}
                  typeOfInput="password"
                  onChange={(newPass) => this.setState({ newPass })}
                />
                <LabelWithValueField
                  labelName={t('CONFIRM_NEW_PASSWORD')}
                  style={{ marginTop: '20px' }}
                  value={this.state.confirmNewPass}
                  typeOfInput="password"
                  onChange={(confirmNewPass) => this.setState({ confirmNewPass })}
                />
              </div>
            ) : null}
            {this.state.editUserErrorInfo ? this.showErrorMessage() : null}
          </div>
        </Modal>
      </Portal>
    );
  }
}

const styles = {
  userInfo: {
    height: '150px',
    width: '100%',
    borderRadius: '3px',
    backgroundColor: 'var(--dropdown-bg-selected)',
    paddingTop: '15px',
    marginBottom: '10px'
  },
  changePassword: {
    height: '19px',
    color: '#7A7A7A',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '19px',
    marginLeft: '5px'
  },
  passwordLabel: {
    height: '15px',
    color: '#B5B5B5',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '1px',
    lineHeight: '15px',
    marginLeft: '5px',
    marginTop: '20px'
  },
  passValue: {
    width: '100%',
    padding: '0.5em',
    //color: '#000000',
    border: 'none',
    fontFamily: 'Montserrat',
    borderRadius: '2px',
    //backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
    fontSize: '16px',
    marginTop: '10px'
  },
  errorMessage: {
    color: '#DF2714',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    lineHeight: '18px',
    wordWrap: 'break-word',
    marginBottom: '20px'
  },
  editIcon: {
    float: 'right'
  },
  email: {
    height: '19px',
    color: '#B5B5B5',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    lineHeight: '19px',
    textAlign: 'center'
  }
};
